export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.path === "/_ready") return;
  const { loggedIn } = useUserSession();
  const { profile, getProfile } = useProfile();

  const { site } = useSite();

  if (to.path.startsWith(`/notfound`)) return;
  if (to.path.startsWith(`/disabled`)) return;

  // Always skip checking if auth route
  if (to.path.startsWith(`/auth/`)) return;

  if (!site.value) {
    return navigateTo("/notfound");
  }

  const provider = site.value.settings?.oauthprovider;
  if (typeof provider !== "string" || !provider.trim()) {
    console.error("Site OAuth provider is missing");
    return navigateTo("/disabled");
  }

  console.log(`User is on site: ${site.value?.name}`);
  console.log(`Site uses ${provider} for authentication`);

  if (!loggedIn.value) {
    console.log(`User not logged in, redirecting to auth...`);
    return navigateTo(`/auth/${provider}?redirect=${to.path}`, { external: true });
  }

  // Always skip checking if onboarding route
  if (to.path.startsWith(`/on-boarding`)) return;

  await getProfile();

  if (!profile.value) {
    console.log(`User profile not found, redirecting to auth...`);
    return navigateTo(`/auth/${provider}?redirect=${to.path}`, { external: true });
  }

  if (profile.value?.flags.missing_profile) {
    console.log(`User profile is incomplete, redirecting to on-boarding...`);
    // Preserve original destination so onboarding can send the user there afterwards.
    // Use fullPath to include query params; guard against sending user back to onboarding or auth loop.
    const target = to.fullPath || to.path;
    const unsafe = /\/on-boarding|^\/auth\//i.test(target);
    const encoded = encodeURIComponent(unsafe ? '/' : target);
    return navigateTo(`/on-boarding?redirect=${encoded}`);
  }
});
